import { useAtom } from '@reatom/npm-react'
import { useMemo } from 'react'
import styled from 'styled-components'

import {
  reatomFollowersFilter,
  UserConnectionsFollowers,
} from '@root/features/user/user-connections'
import { UsersSearch } from '@root/features/user/users-search/ui/users-search'
import { WhoToFollowList } from '@root/features/user/who-to-follow/ui/who-to-follow-list'

import { UserConnectionsBoardFollowersEmpty } from './user-connections-board-followers-empty'

import type { DelugeId } from '@root/entities/user-short'

type UserConnectionsBoardFollowersProps = {
  delugeId: DelugeId
  /** Whether to draw the empty state, which is not the same as a loaded zero. */
  followersCount: number
}

export const UserConnectionsBoardFollowers = ({
  delugeId,
  followersCount,
}: UserConnectionsBoardFollowersProps) => {
  const followersFilter = useMemo(
    // eslint-disable-next-line @reatom/unit-naming-rule
    () => reatomFollowersFilter(delugeId),
    [delugeId],
  )
  const [searchQuery, setSearchQuery] = useAtom(followersFilter.searchQueryAtom)

  const noFollowers = followersCount === 0

  if (noFollowers) {
    return <UserConnectionsBoardFollowersEmpty userId={delugeId} />
  }

  return (
    <Root>
      <Content>
        <Head>
          <UsersSearch
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
          />
        </Head>
        <UserConnectionsFollowers followersFilter={followersFilter} />
      </Content>
      <WhoToFollow delugeId={delugeId} />
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  padding: 10px;

  &[data-empty='true'] {
    padding: 6px;
  }
`

const Head = styled.div`
  z-index: 1;
  position: sticky;
  top: 0;
  padding: 12px 0;
  background: var(--background-1);
`

const Content = styled.div`
  display: grid;
  grid-template-rows: auto 1fr;
  padding: 0 16px 12px 6px;
  overflow: auto;
`

const WhoToFollow = styled(WhoToFollowList)`
  margin-top: -40px;
  width: 300px;
`
